import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=f376278e&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=f376278e&prod&lang=less&scoped=true"
import style1 from "./EmailList.vue?vue&type=style&index=1&id=f376278e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f376278e",
  null
  
)

export default component.exports